var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"status-chart",staticClass:"donut-chart",attrs:{"options":_vm.options,"series":_vm.series,"type":"donut","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }